import { getConfig } from '@shared/config/runtime.js';

export default {
    computed: {
        api_base_url: function () {
            return getConfig().api_base_url;
        },
    },
    methods: {
        imgAvatar: function (atleta) {
            if (!atleta.url_fotoprofilo) return "";
            let base = getConfig().api_base_url + "/avatar.php?f=";
            return base + atleta.url_fotoprofilo;
        },
        nomeAtleta: function (atleta) {
            const cognome = this.nome(atleta);
            const nome = this.cognome(atleta);
            return cognome + ' ' + nome;
        },
        cognome: function (atleta) {
            return (atleta.atleta_cognome) ? atleta.atleta_cognome : atleta.cognome;
        },
        nome: function (atleta) {
            return (atleta.atleta_nome) ? atleta.atleta_nome : atleta.nome;
        },
        iniziali: function (atleta) {
            const cognome = this.cognome(atleta) || '';
            const nome = this.nome(atleta) || '';
            return cognome.substr(0,1).toUpperCase() + nome.substr(0,1).toUpperCase();
        },
    }
};
